import React from "react";
import "./PackagesWorkshops.css";
import PackagesInfofrom from "../../store/PackagesWorkshopsInfo.js";
import PackagesChild from './TrackWorkshops/TrackWorkshops.jsx'

const Packages = () => {
  let packagesElements = PackagesInfofrom.map((PackagesItem, i) => {
    return <PackagesChild key={`track_item_workshop-${i}`} track={PackagesItem} />;
  });
  return (
    <div className="w_packages-wrap" id='w-tickets'>
      <div className='container w_packages'>
        <h2 className="w_packages-h2">SPECIAL OFFER</h2>
        <p className="p2 w_packages-p2">Buy a ticket for the Pro track together with the workshop and get a 50% discount</p>
        <div className='w-track_wrap'>
          {packagesElements}
        </div>
      </div>
    </div>
  );
};
export default Packages;